import dayjs from 'dayjs'

/**
 * Single source of truth for today, to have a fixed single value across the application.
 */
export const today = new Date()
export const getAge = (birthday: Date): number => dayjs(today).diff(dayjs(birthday), 'years')

export const date18YearsAgo = dayjs(today).subtract(18, 'year').toDate()
